import { useState } from "react";

const faqs = [
  {
    question: "À quelle vitesse intervenez-vous à Hœnheim ?",
    answer:
      "Hœnheim est à quelques minutes de notre atelier de Strasbourg. Pour une fenêtre bloquée ou une poignée cassée, nous intervenons souvent le jour même, parfois en 2 à 4 heures. Les réparations programmées sont fixées sous 24 heures. Le déplacement est gratuit, le diagnostic est gratuit, et le devis est détaillé avant toute intervention.",
  },
  {
    question: "Y a-t-il des frais cachés ?",
    answer:
      "Non, absolument pas. Le devis que nous vous remettons précise le coût de la pièce, la main-d'œuvre et le prix total. Vous l'acceptez ou non, sans engagement. Si vous acceptez, l'intervention se fait sur place et vous payez à l'issue des travaux. Pas d'avance, pas de frais cachés, pas de surprise. Le déplacement est offert dans tout le Bas-Rhin.",
  },
  {
    question: "Quels types de fenêtres réparez-vous à Hœnheim ?",
    answer:
      "Nous réparons tous les types de fenêtres : PVC, aluminium, bois, anciennes ou récentes. Hœnheim compte des maisons individuelles avec jardins, des petits immeubles et des résidences calmes. Nos techniciens sont équipés pour intervenir dans tous les contextes. Toutes les marques sont prises en charge : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi, Cadiou. Chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Hœnheim
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-rose-50 rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}